import { useState } from "react";
import { uploadCommunityPortalMedia } from "services/communityPortalMedia.service";
import { renderErrorNotifications } from "helpers/error.helpers";

/**
 * Wraps uploadCommunityPortalMedia into a hook.
 * Returns { upload, uploading, percent }.
 * upload(file) -> resolves to the uploaded URL string, or null on failure.
 */
export default function useUploadMedia() {
  const [uploading, setUploading] = useState(false);
  const [percent, setPercent] = useState(0);

  const upload = async (file) => {
    setUploading(true);
    setPercent(0);
    const { data, errors } = await uploadCommunityPortalMedia(file, {
      onUploadProgress: (e) => {
        if (e.total) setPercent(Math.round((e.loaded / e.total) * 100));
      },
    });
    setUploading(false);
    setPercent(0);
    if (errors?.length > 0) {
      renderErrorNotifications(errors);
      return null;
    }
    return data?.url ?? null;
  };

  return { upload, uploading, percent };
}
